module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxwYXRoIGQ9Ik0xMy43MjggNi4yNzJ2MTkuNDU2cTAgMC40NDgtMC4zNTIgMC44dC0wLjggMC4zMi0wLjgtMC4zMmwtNS45NTItNS45NTJoLTQuNjcycS0wLjQ4IDAtMC44LTAuMzUydC0wLjM1Mi0wLjh2LTYuODQ4cTAtMC40OCAwLjM1Mi0wLjh0MC44LTAuMzUyaDQuNjcybDUuOTUyLTUuOTUycTAuMzItMC4zMiAwLjgtMC4zMnQwLjggMC4zMiAwLjM1MiAwLjh6Ij48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/volume-off.svg
// module id = 5tJB
// module chunks = 30